/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for InvoiceContext controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { S10InvoicePayload, RequestOptions, InvoiceContextResponse } from "../models";

@Injectable({ providedIn: "root" })
export class InvoiceContextService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    receiveInvoiceContextApiInvoiceContextPost(s10InvoicePayload: S10InvoicePayload, observe?: 'body', options?: RequestOptions<'json'>): Observable<InvoiceContextResponse>;
    receiveInvoiceContextApiInvoiceContextPost(s10InvoicePayload: S10InvoicePayload, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<InvoiceContextResponse>>;
    receiveInvoiceContextApiInvoiceContextPost(s10InvoicePayload: S10InvoicePayload, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<InvoiceContextResponse>>;
    /** Receive invoice context from S10 and persist via data-access */
    receiveInvoiceContextApiInvoiceContextPost(s10InvoicePayload: S10InvoicePayload, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/invoice_context`;

        const requestOptions: any = {
            observe: observe as any,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, s10InvoicePayload, requestOptions);
    }
}
